<div class="drop-zone" [ngClass]="{'drop-hover': isDragHover && !disabled }"
     (drop)="onDrop($event)"
     (dragenter)="onDragEnter($event)"
     (dragleave)="onDragLeave($event)"
     (dragover)="onDragOver($event)">
  <div class="drop-zone__text">
    <cm-icon name="upload" class="upload-icon"></cm-icon>
    Drop {{ isMultipleFiles ? 'files' : 'file' }} to attach, or
    <label for="{{randomId}}" class="drop-zone__browse" [ngClass]="{'drop-zone__browse_hover': !disabled}">Browse</label>
    <input
      *ngIf="!disabled"
      id="{{randomId}}"
      type="file"
      class="hidden"
      (change)="onFilesSelect($event)"
      [multiple]="isMultipleFiles"
      hidden
      accept="{{allowedTypes}}">
  </div>
</div>
